import {router} from "@inertiajs/react";
import {useEchoSubscription} from "@/components/WebSocketEcho";
import {notifications} from "@/Logigate/componentes/notificacoes";
import {Botao} from "@/Logigate/ui";
import {guardarNaBibliotecaDisponivel, pedirGuardarNaBiblioteca} from "@/Logigate/components/GuardarNaBiblioteca/OuvinteGuardarNaBiblioteca";

interface ExportNotificationData {
    tarefa_id: number;
    nome: string;
    estado: 'ok' | 'erro';
    texto: string;
    download_url: string | null;
}

interface UseExportNotificationOptions {
    channelName: string;
    enabled?: boolean;
    processosUrl?: string;
}

/**
 * Aviso do fim de uma exportação em segundo plano (pelo canal privado do administrador ou da
 * secretaria). É o `notifications` do `@/Logigate/componentes` (o gémeo Tailwind do Mantine):
 * aparece em cima, não pára quem está a trabalhar e monta-se sozinho — fora da árvore da
 * página, por isso os botões navegam pelo `router` e não por `<Link>`.
 */
export function useExportNotification({channelName, enabled = true, processosUrl}: UseExportNotificationOptions) {
    useEchoSubscription({
        channelName,
        enabled: enabled && !!channelName,
        events: {
            ExportacaoConcluida: (data: ExportNotificationData) => {
                const isSuccess = data.estado === 'ok';
                const download = isSuccess ? data.download_url : null;
                const guardar = !!download && guardarNaBibliotecaDisponivel();

                notifications.show({
                    title: isSuccess ? 'Exportação concluída' : 'Exportação falhou',
                    message: (
                        <>
                            <p>{data.texto}</p>
                            {(download || processosUrl) && (
                                <div className="mt-2.5 flex flex-wrap gap-2">
                                    {download && (
                                        // Navegar para o ficheiro descarrega-o sem sair da página (como o `<a href>` de antes).
                                        <Botao tamanho="sm" cor="green" className="max-md:h-10" onClick={() => window.location.assign(download)}>
                                            Baixar ficheiro
                                        </Botao>
                                    )}
                                    {download && guardar && (
                                        <Botao tamanho="sm" variante="neutro" className="max-md:h-10" onClick={() => pedirGuardarNaBiblioteca(download)}>
                                            Guardar na gestão documental
                                        </Botao>
                                    )}
                                    {processosUrl && (
                                        <Botao tamanho="sm" variante="neutro" className="max-md:h-10" onClick={() => router.visit(processosUrl)}>
                                            Ver processos
                                        </Botao>
                                    )}
                                </div>
                            )}
                        </>
                    ),
                    color: isSuccess ? 'green' : 'red',
                    autoClose: 20000,
                    withCloseButton: true,
                });
            },
        },
    });
}
